import {createRouter, createWebHashHistory} from 'vue-router';
import caseidStart from '../components/caseid-start.vue';
import searchStart from '../components/search-start.vue';
import searchOverview from '../components/search-overview.vue';
import searchRecordSelection from '../components/search-record-selection.vue';
import recordModification from '../components/record-modification.vue';
import permalinkView from '../components/permalink-view.vue';
import login from '../components/login.vue';
import authenticateApi from '../api/auth';
import remediationApi from '../api/remediation';
import store from '../store/index';
import { CASEID } from '../store/keys';
import { subscribe as subscribeToApi } from '../api/rest';

const router = createRouter({
    mode: 'history',
    history: createWebHashHistory(),
	routes: [
		{
			path: '/',
			name: 'index',
			redirect: {
				name: 'caseidStart'
			}
		},
		{
			path: '/login',
			name: 'login',
			component: login
		},
		{
			path: '/logout',
			name: 'logout',
			beforeEnter(to, from, next) {
				authenticateApi.logOut();
				return next({ name: 'login' });
			}
		},
		{
			path: '/caseid-start',
			name: 'caseidStart',
			component: caseidStart,
			meta: { needAuthentication: true }
		},
        {
            path: '/search-start',
            name: 'searchStart',
            component: searchStart,
            meta: { needAuthentication: true, needCaseId: true }
        },
        {
            path: '/search-overview',
            name: 'searchOverview',
            component: searchOverview,
            meta: { needAuthentication: true, needCaseId: true }
        },
        {
            path: '/search-record-selection',
            name: 'searchRecordSelection',
            component: searchRecordSelection,
            meta: { needAuthentication: true, needCaseId: true }
        },
        {
            path: '/record-modification',
            name: 'recordModification',
            component: recordModification,
            meta: { needAuthentication: true, needCaseId: true }
        },
        {
            path: '/permalink/:id/download',
            name: 'permalinkViewDownload',
            beforeEnter(to, from, next) {
                const remediationId = to.params.id;
                remediationApi.get(remediationId).then((remediationJson) => {
                    const json = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(remediationJson, null, 2))}`;
                    const downloadRoute = document.getElementById('download-from-route');
                    downloadRoute.setAttribute('href', json);
                    downloadRoute.setAttribute('download', `remediation-${remediationId}.json`);
                    downloadRoute.click();
                    return next({name: 'permalinkView', params: {id: remediationId}});
                }).catch(console.error);
            }
        },
		{
			path: '/permalink/:id',
			name: 'permalinkView',
			component: permalinkView
		}
	]
});

router.beforeEach((to, from, next) => {
    const checkCaseId = () => {
        if (to.matched.some(record => record.meta.needCaseId)) {
            if (store.getters[CASEID].length > 0) {
                return next();
			}
            return next({
                name: 'caseidStart',
                query: { redirect: to.fullPath }
            });
        }
        return next();
    };
    if (to.matched.some(record => record.meta.needAuthentication)) {
		return authenticateApi.isLoggedIn().then(
			() => checkCaseId(),
			() => next({
                name: 'login',
                query: { redirect: to.fullPath }
            })
		);
    }

    checkCaseId();
});

// Redirect to login, when request calls are rejected with 403 response status.
subscribeToApi(request => {
	request.catch(err => {
		if (err === 403) {
			router.replace({name: 'login'});
		}
	});
});

export default router;
